/*@ngInject*/
const FilesAndIconsManagerRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getConfiguredFiles = function () {
        const url = '/rest/ConfiguredFile/List';

        return this.get(url);
    };

    this.saveConfiguredFile = function (configuredFile) {
        const url = this.buildSaveOrUpdateUrl(configuredFile.id);
        let formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                },
                params: {
                    name: configuredFile.name,
                    description: configuredFile.description,
                    carrierOnly: configuredFile.carrierOnly,
                    grouping: configuredFile.grouping,
                    required: configuredFile.required,
                    fileName: configuredFile.fileName,
                    fileSize: !_.isNil(configuredFile.file) ? configuredFile.file.size : null
                }
            };

        formData.append('data', configuredFile.file);

        return this.post(url, formData, config);
    };

    this.buildSaveOrUpdateUrl = function (configureFileId) {
        return _.isNil(configureFileId) ? '/rest/ConfiguredFile' : '/rest/ConfiguredFile/' + configureFileId;
    };

    this.deleteConfiguredFile = function (configuredFileId) {
        const url = '/rest/ConfiguredFile/' + configuredFileId;

        return this.delete(url);
    };
};

angular.module('ums.configuration')
    .service('filesAndIconsManagerRepository', FilesAndIconsManagerRepository);
